module.exports = __webpack_public_path__ + "img/flyingofbee_1.c55e9f6b.jpg";